import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { HpBlockSchema } from "../player/HpBlock";

@Component("HpBlockEnhancer")
export class HpBlockEnhancerSchema extends Schema {
  @type(["string"])
  @defaultValue([])
  excludedTypes: string[];
}

class HpBlockEnhancerSystem implements System {
  schema = HpBlockEnhancerSchema;
  type = "HpBlockEnhancer";
  dependencies = ["Child", "HpScaler"];
  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      const data = gameModel.getTypedUnsafe(entity, HpBlockEnhancerSchema);

      if (!gameModel.hasComponent(parent, HpBlockSchema)) {
        gameModel.addComponent(parent, HpBlockSchema, {
          excludedTypes: data.excludedTypes,
        });
      }
    }
  }

  cleanup(entity: number, gameModel: GameModel, ejecting: boolean) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      gameModel.removeComponent(parent, HpBlockSchema);
    }
  }
}

registerSystem(HpBlockEnhancerSystem);
